import api from './apiInstance';

// Auth service functions
export async function loginUser(email: string, password: string) {
  try {
    const response = await api.post<{ status: string, data: { user: any, token: string } }>(
      '/auth/login', 
      { email, password }
    );
    return response.data.data;
  } catch (error) {
    console.error('Login failed:', error);
    throw error;
  }
}

export async function getCurrentUser() {
  try {
    const response = await api.get<{ status: string, data: any }>('/auth/me');
    return response.data.data;
  } catch (error) {
    console.error('Failed to get current user:', error);
    throw error;
  }
}
